import type { Endpoint } from '../../features/catalog/model';
import { FieldCard } from './FieldCard';
import { ResponseCard } from './ResponseCard';
import { referenceRows } from './referenceRows';
import { m } from '../../paraglide/messages';

export interface EndpointReferenceContentProps {
  endpoint: Endpoint;
  /** the SKU's request JSON Schema, when the gateway published one */
  inputSchema?: unknown;
  /** the SKU's response JSON Schema, when the gateway published one */
  outputSchema?: unknown;
}

/**
 * The dashboard's statement of the contract: what you send and what you get
 * back, side by side, under the dashboard section's own heading.
 */
export const EndpointReferenceContent = ({
  endpoint,
  inputSchema,
  outputSchema,
}: EndpointReferenceContentProps) => {
  const rows = referenceRows(endpoint, inputSchema, outputSchema);
  return (
    <div className="grid gap-4 md:grid-cols-2 md:items-start">
      <FieldCard
        title={m.endpoint_card_you_send()}
        caption="The JSON body of the request."
        rows={rows.request}
      />
      <ResponseCard
        endpoint={endpoint}
        outputSchema={outputSchema}
        title={m.endpoint_card_you_get()}
        caption="The JSON response."
        rows={rows.response}
        requirable={rows.requirable}
      />
    </div>
  );
};
